import { apiRequest } from './config';

/**
 * Categories API - Optimized with ISR and granular caching
 */

export const getCategories = (params = {}) => 
  apiRequest('categories', { 
    method: 'GET', 
    params,
    next: {
      tags: ['categories', 'category-list', 'products']
    }
  });

export const getCategory = (id) => 
  apiRequest(`categories/${id}`, {
    next: {
      tags: ['categories', `category-${id}`, 'products']
    }
  });

export const getCategoryBySlug = (slug, params = {}) => 
  apiRequest(`categories/${slug}`, {
    params,
    next: {
      tags: ['categories', `category-${slug}`, 'products']
    }
  });

export const createCategory = (categoryData) => 
  apiRequest('categories', {
    method: 'POST',
    body: JSON.stringify(categoryData),
  });

export const updateCategory = (id, categoryData) => 
  apiRequest(`categories/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(categoryData),
  });

export const deleteCategory = (id) => 
  apiRequest(`categories/${id}`, { method: 'DELETE' });
